export const environment = {
  production: false,
  //apiUrl: 'http://localhost:3001',
  apiUrl: 'https://mercantil.dev.apisaude.com.br',
  googleMapsApiKey: 'AIzaSyBErVRRwQ5d5qQ4oMTFqwXE4WBRcn61X3c',
  storage: {
    tokenKey: 'auth_token',
    rememberKey: 'remember_me',
    userKey: 'user_data',
  },
  upload: {
    maxSize: '1 MB',
    recommendedSize: '624 x 350',
    acceptedFiles: ['jpg', 'png'],
  },
};
